//EXTERNAL
import React, { useState, useEffect } from "react"
//COMPONENTS
import DetectAdBlock from "./detectAdBlocker"
import Routes from "./Routes"
//ASSETS
//FUNCTIONS

export default function App({ props }) {
  const [isDesktop, setIsDesktop] = useState(document.documentElement.clientWidth > 650)

  const handleResize = () => {
    document.documentElement.clientWidth > 650 ? setIsDesktop(true) : setIsDesktop(false)
  }
  useEffect(() => {
    document.title = `creative preview - Picnic`
    window.addEventListener("resize", handleResize, { passive: true })
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  })

  return (
    <div className={"app"}>
      <Routes isDesktop={isDesktop} />
      <DetectAdBlock />
    </div>
  )
}
